import { Unit, WHATSAPP_NUMBER } from './data';

declare global {
  interface Window {
    gtag_report_conversion?: (url: string) => void;
    dataLayer?: Record<string, unknown>[];
  }
}

export const buildWhatsAppUrl = (unit: Unit): string => {
  const message = `Olá! Vim pelo site do Studio Corpo & Alma e quero agendar uma aula experimental grátis na Unidade ${unit.neighborhood.toUpperCase()}.`;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
};

export const openWhatsApp = (unit: Unit, source: string): void => {
  const url = buildWhatsAppUrl(unit);

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: 'whatsapp_click', unidade: unit.id, origem_clique: source });

  if (window.gtag_report_conversion) {
    window.gtag_report_conversion(url);
  } else {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
};
